export default "__VITE_ASSET__6NGE$ZzM__"